import React from "react";

const CategoryContents = ({ title, subCategory }) => {
  return (
    <div className="h-[430px] flex flex-col">
      <h2 className="font-semibold text-[14px]">{title}</h2>
      <hr className="bg-[#FF8100] w-[209px] h-[4px] rounded-full mt-[7px] mb-[15px]" />
      <div className="scroll-container overflow-y-scroll w-full h-[380px]">
        <div className="flex flex-wrap gap-x-[27px] gap-y-[38px] mt-[35px] w-[900px]">
          {subCategory && subCategory.length > 0 ? (
            subCategory.map((category, index) => (
              <button key={index}>
                <div className="flex flex-col items-center w-[155px] h-[100px] gap-y-[6px]">
                  <p className="flex items-center justify-center w-[58px] h-[58px] rounded-full bg-[#F2F2F2]">
                  <img
                    className="w-[33px] h-[33px]"
                    src={category?.subCategoryImage} // Dynamic image source
                    alt={`${category.name} Image`}
                  />
                  </p>
                  <h2 className="text-[12px] font-medium">
                    {category.subCategory}
                  </h2>
                </div>
              </button>
            ))
          ) : (
            <p className="text-[16px] text-black font-medium w-auto">No sub-categories available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryContents;
